import { useTranslation } from "react-i18next"
import { ControlGroup } from "../ControlGroup"
import { type ExportDetails } from "./export-details-utils"

const ExportDetailsList = (props: {
	title: string
	filenames: string[]
	emptyMessage: string
	description?: string
}) => {
	return (
		<ControlGroup
			name={`${props.title} (${props.filenames.length})`}
			compact
			hideSeparator
			fullSizeContent
		>
			{props.description && (
				<div className="mb-2 text-xs text-base-400">{props.description}</div>
			)}
			<div className="max-h-[220px] overflow-y-auto rounded border border-base-700 bg-base-900/50 p-2">
				{props.filenames.length > 0 ? (
					<ul className="space-y-1 text-xs text-base-200">
						{props.filenames.map((filename, index) => (
							<li key={`${filename}-${index}`} className="break-all">
								{filename}
							</li>
						))}
					</ul>
				) : (
					<div className="text-xs text-base-400">{props.emptyMessage}</div>
				)}
			</div>
		</ControlGroup>
	)
}

export const ExportDetailsView = (props: { details: ExportDetails }) => {
	const { t } = useTranslation("components")
	const flow = props.details.flow

	return (
		<div className="flex min-h-0 flex-col gap-4">
			<ExportDetailsList
				title={t(`exportDetailsView.${flow}CompletedGroupName`)}
				filenames={props.details.completedFilenames}
				emptyMessage={t(`exportDetailsView.${flow}EmptyCompletedMessage`)}
			/>
			{props.details.failedFilenames.length > 0 && (
				<ExportDetailsList
					title={t(`exportDetailsView.${flow}FailedGroupName`)}
					filenames={props.details.failedFilenames}
					emptyMessage={t(`exportDetailsView.${flow}EmptyFailedMessage`)}
				/>
			)}
			{props.details.oversizeFilenames.length > 0 && (
				<ExportDetailsList
					title={t("exportDetailsView.oversizeGroupName")}
					filenames={props.details.oversizeFilenames}
					emptyMessage={t("exportDetailsView.oversizeEmptyMessage")}
					description={t("exportDetailsView.oversizeDescription")}
				/>
			)}
		</div>
	)
}
